import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/participations/$uuid/")({
  beforeLoad: ({ params, location }) => {
    if (location.pathname === `/participations/${params.uuid}`) {
      throw redirect({
        to: "/participations/$uuid/$tab",
        params: { uuid: params.uuid, tab: "overview" },
      });
    }
  },
});
